import React from "react";

const FormInput = ({
  id,
  label,
  value = "",
  onChange,
  disabled = false,
  invalid = false,
  placeholder = "",
  required = false,
  onZipSearch, // new callback
}) => {

  return (
    <div className="flex items-start gap-4 w-full mb-4">
      {label && (
        <label
          htmlFor={id}
          className="text-base font-medium text-black whitespace-nowrap flex-shrink-0 pt-2"
        >
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {disabled ? (
        <div
          id={id}
          className="flex-1 min-w-[200px] px-3 py-2 bg-slate-50 border-0 border-b-2 text-base font-medium text-black border-b-gray-300 rounded-md min-h-[3rem]"
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {value || placeholder}
        </div>
      ) : id === "zip" ? (
        <div className="relative flex-1 min-w-[200px]">
          <textarea
            id={id}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={`w-full px-3 py-2 pr-10 bg-slate-50 border-0 border-b-2 text-base font-medium text-black rounded-md resize-none min-h-[3rem]
              ${invalid ? "border-b-red-500" : "border-b-gray-300"}
            `}
          />
          <button
            type="button"
            onClick={onZipSearch}
            className="absolute right-2 top-2 p-1 text-blue-500 hover:text-blue-700"
          >
            <i className="fas fa-search"></i>
          </button>
        </div>
      ) : (
        <textarea
          id={id}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`flex-1 min-w-[200px] px-3 py-2 bg-slate-50 border-0 border-b-2 text-base font-medium text-black rounded-md resize-y min-h-[3rem]
            ${invalid ? "border-b-red-500" : "border-b-gray-300"}
          `}
        />
      )}
    </div>
  );
};

export default FormInput;
